import { AppointmentPhase, Status } from "components";
import ListTemplate from "components/ListTemplate";
import { ProductionSidePanel } from "components/SidePanel/Production/ProductionSidePanel";
import SmallDetails from "components/SmallDetails/SmallDetails";
import React from "react";
import { useLoaderData } from "react-router";
import Filters from "./Filters";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";

export const ProductionListApp = () => {
  const viewModel = useLoaderData<server.viewmodel.ProductionListFrontModel>();

  return <ListTemplate
    title={site.currentEnvironment.tour.plural}
    filterSet="production_List"
    defaultFilters={viewModel.defaultFilters}
    initialInstruction={viewModel.initialInstruction}
    fetchFunction={window.CoreApi.Production.Paginated}
    getId={item => item.productionId}
    layout={{
      type: "table",
      columns: [{
        key: "date",
        header: RESX.DateTime.lblDate,
        render: item => <SmallDetails
          label={item.startDateWritten}
          subLabel={item.endDateWritten}
        />,
        size: "auto"
      }, {
        key: "name",
        header: RESX.GeneralLabels.Name,
        render: item => <ProductionSidePanel productionId={item.productionId} trigger={<a>{item.name}</a>} />,
        size: "1.5fr"
      }, {
        key: "status",
        header: RESX.Status.resxStatus,
        render: item => <Status status={item.status} />,
        hidden: viewModel.statuses.length <= 1,
        size: "1fr"
      }, {
        key: "artist",
        header: site.currentEnvironment.functionGroups.artist.singular,
        render: item => item.artists.map(a => <div key={a}>{a}</div>),
        size: "1.5fr"
      }, {
        key: "shows",
        header: site.currentEnvironment.show.plural,
        className: "s1_cell_financialamount",
        render: item => item.showCount.map(show => <div
          key={show.phase}
          className="flex gap-small justify-end"
        >
          {show.count}
          <AppointmentPhase value={show.phase} displayLabel={false} />
        </div>),
        size: "auto"
      }]
    }}
    filters={<Filters initialStatuses={viewModel.statuses} />}
    functions={{
      mapResponseToFilterValues,
      mapFilterValuesToInstruction
    }}
    options={{
      exportOptions: {
        canExportList: site.permissions.tour.canExportList,
        exportOptionsApi: window.CoreApi.Production.ExportOptionsForList
      }
    }}
  />;
};